'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mergeOptions = require('merge-options');

var _mergeOptions2 = _interopRequireDefault(_mergeOptions);

var _componentContext = require('@spp/component-context');

var _hyperionWebComponents = require('@spp/hyperion-web-components');

var _hyperionWebComponents2 = _interopRequireDefault(_hyperionWebComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Article = function (_Component) {
    (0, _inherits3.default)(Article, _Component);

    function Article() {
        (0, _classCallCheck3.default)(this, Article);
        return (0, _possibleConstructorReturn3.default)(this, (Article.__proto__ || (0, _getPrototypeOf2.default)(Article)).apply(this, arguments));
    }

    (0, _createClass3.default)(Article, [{
        key: 'render',

        /* eslint-disable react/forbid-prop-types */
        value: function render() {
            var _props = this.props,
                localComponentsMapping = _props.localComponentsMapping,
                _props$data = _props.data,
                irisComponents = _props$data.components,
                articleId = _props$data.id,
                themeProviderConfig = _props.themeProviderConfig;

            // merge the default components with the ones provided as props

            var finalComponentsMapping = (0, _mergeOptions2.default)(_hyperionWebComponents2.default, localComponentsMapping);

            return _react2.default.createElement(
                _componentContext.CurrentArticleProvider,
                { article: this.props.data },
                _react2.default.createElement(
                    'article',
                    { className: this.props.theme.root },
                    (0, _hyperionWebComponents.renderComponents)(irisComponents, finalComponentsMapping, themeProviderConfig, articleId)
                )
            );
        }
        /* eslint-enable react/forbid-prop-types */

    }]);
    return Article;
}(_react.Component);

Article.propTypes = {
    localComponentsMapping: _propTypes2.default.object,
    data: _propTypes2.default.shape({
        components: _propTypes2.default.array
    }),
    theme: _propTypes2.default.object,
    themeProviderConfig: _propTypes2.default.object
};
Article.defaultProps = {
    localComponentsMapping: {},
    data: {
        components: []
    },
    theme: {},
    themeProviderConfig: {}
};
exports.default = Article;
//# sourceMappingURL=Article.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/article/lib/cjs/Article.js
 ** module id = 470
 ** module chunks = 1
 **/